import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import { CompareSchemas } from '@gap/utils/utils'
import { AdvisorClientContactEntityType } from '@gap/backend/database/entities/advisor/AdvisorClientContactEntity'
import { advisorClientContactInvitationStatuses, advisorClientContactStatuses } from '@gap/backend/app-services/org/advisor/models/ClientContactEnums'
import { normalisedEmailValidation } from '@gap/backend/util/validations/validation-email'

const AdvisorClientContactEntityDtoSchema = z.object({
   id: z.string({ errorMap }),
   clientId: z.string({ errorMap }),
   advisorOrgId: z.string({ errorMap }),
   primaryContact: z.boolean({ errorMap }),
   status: z.enum(advisorClientContactStatuses),
   invitationStatus: z.enum(advisorClientContactInvitationStatuses),

   name: z.string({ errorMap }),
   firstName: z.string({ errorMap }).min(1).optional(),
   lastName: z.string({ errorMap }).min(1).optional(),
   email: normalisedEmailValidation,
   phoneNumber: z.string({ errorMap }).optional(),

   createdAt: z.string({ errorMap }),
   xeroId: z.string({ errorMap }).optional(),
   lastUpdatedAt: z.string({ errorMap }),
   lastUpdatedBy: z.string({ errorMap }),
})

// Ensure schema is equal to entity. Note, electrodb's EntityItem doesnt have support for optional types, but atleast we can check for variables
0 as CompareSchemas<z.output<typeof AdvisorClientContactEntityDtoSchema>, AdvisorClientContactEntityType>

export default AdvisorClientContactEntityDtoSchema
